import { QuestLayoutConfig } from './types/QuestCircleTypes'

export const SUB_QUEST_LAYOUT: QuestLayoutConfig[] = [
  {
    position: { top: '209rem', left: '293rem' },
    imageSize: {
      width: '20rem',
      height: '20rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  {
    position: { top: '250rem', left: '55rem' },
    imageSize: {
      width: '20rem',
      height: '20rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
]

export const TAPTAP_QUEST_LAYOUT: Record<number, QuestLayoutConfig> = {
  // 0: {
  //   position: { top: '70rem', left: '140rem' },
  //   imageSize: {
  //     width: '48rem',
  //     height: '48rem',
  //   },
  //   fontSize: '18rem',
  //   textOffset: 20,
  // },
  // 1: {
  //   position: { top: '220rem', left: '165rem' },
  //   imageSize: {
  //     width: '48rem',
  //     height: '48rem',
  //   },
  //   fontSize: '18rem',
  //   textOffset: 10,
  // },
  // 2: {
  //   position: { top: '35rem', left: '65rem' },
  //   imageSize: {
  //     width: '48rem',
  //     height: '48rem',
  //   },
  //   fontSize: '18rem',
  //   textOffset: 10,
  // },
  // 3: {
  //   position: { top: '325rem', left: '30rem' },
  //   imageSize: {
  //     width: '48rem',
  //     height: '48rem',
  //   },
  //   fontSize: '18rem',
  //   textOffset: 20,
  // },
  // 4: {
  //   position: { top: '266rem', left: '327rem' },
  //   imageSize: {
  //     width: '48rem',
  //     height: '48rem',
  //   },
  //   fontSize: '18rem',
  //   textOffset: 20,
  // },
  5: {
    position: { top: '33rem', left: '68rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  6: {
    position: { top: '43rem', left: '56rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  7: {
    position: { top: '70rem', left: '140rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  8: {
    position: { top: '45rem', left: '55rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  9: {
    position: { top: '45rem', left: '55rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  10: {
    position: { top: '45rem', left: '55rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  11: {
    position: { top: '45rem', left: '55rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  12: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  13: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  14: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  15: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  16: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
  17: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },  
  18: {
    position: { top: '60rem', left: '180rem' },
    imageSize: {
      width: '48rem',
      height: '48rem',
    },
    fontSize: '18rem',
    textOffset: 20,
  },
}

export const MAIN_QUEST_LAYOUT: Record<number, QuestLayoutConfig> = {
  1: {
    position: { top: '30rem', left: '288rem' },
    imageSize: {
      width: '75rem',
      height: '75rem',
    },
    fontSize: '20rem',
    textOffset: -10,
  },
  2: {
    position: { top: '285rem', left: '157rem' },
    size: {
      width: '100%',
      height: '100%',
      left: '-14%',
      top: '5%',
    },
    imageSize: {
      width: '64rem',
      height: '64rem',
    },
    fontSize: '16rem',
    textOffset: 20,
  },
  3: {
    position: { top: '157rem', left: '90rem' },
    size: {
      width: '90%',
      height: '90%',
      left: '-4%',
      top: '10%',
    },
    imageSize: {
      width: '39rem',
      height: '39rem',
    },
    fontSize: '12rem',
    textOffset: -20,
  },
}

export const PAGE_QUEST_LAYOUTS: Record<
  number,
  Partial<Record<number, QuestLayoutConfig>>
> = {
  1: {
    1: {
      position: { top: '30rem', left: '288rem' },
      imageSize: {
        width: '75rem',
        height: '75rem',
      },
      fontSize: '20rem',
      textOffset: -10,
    },
    2: {
      position: { top: '245rem', left: '45rem' },
      size: {
        width: '100%',
        height: '100%',
        left: '-14%',
        top: '5%',
      },
      imageSize: {
        width: '64rem',
        height: '64rem',
      },
      fontSize: '16rem',
      textOffset: 20,
    },
    3: {
      position: { top: '75rem', left: '145rem' },
      size: {
        width: '90%',
        height: '90%',
        left: '-4%',
        top: '10%',
      },
      imageSize: {
        width: '39rem',
        height: '39rem',
      },
      fontSize: '12rem',
      textOffset: -20,
    },
  },
  5: {
    1: {
      position: { top: '30rem', left: '288rem' },
      imageSize: {
        width: '75rem',
        height: '75rem',
      },
      fontSize: '20rem',
      textOffset: -10,
    },
    2: {
      position: { top: '245rem', left: '45rem' },
      size: {
        width: '100%',
        height: '100%',
        left: '-14%',
        top: '5%',
      },
      imageSize: {
        width: '64rem',
        height: '64rem',
      },
      fontSize: '16rem',
      textOffset: 20,
    },
    3: {
      position: { top: '75rem', left: '145rem' },
      size: {
        width: '90%',
        height: '90%',
        left: '-4%',
        top: '10%',
      },
      imageSize: {
        width: '39rem',
        height: '39rem',
      },
      fontSize: '12rem',
      textOffset: -20,
    },
  },
  9: {
    1: {
      position: { top: '30rem', left: '288rem' },
      imageSize: {
        width: '75rem',
        height: '75rem',
      },
      fontSize: '20rem',
      textOffset: -10,
    },
    2: {
      position: { top: '245rem', left: '45rem' },
      size: {
        width: '100%',
        height: '100%',
        left: '-14%',
        top: '5%',
      },
      imageSize: {
        width: '64rem',
        height: '64rem',
      },
      fontSize: '16rem',
      textOffset: 20,
    },
    3: {
      position: { top: '75rem', left: '145rem' },
      size: {
        width: '90%',
        height: '90%',
        left: '-4%',
        top: '10%',
      },
      imageSize: {
        width: '39rem',
        height: '39rem',
      },
      fontSize: '12rem',
      textOffset: -20,
    },
  },
}

export function getQuestLayoutForPage(
  pageIndex: number,
  layoutIndex: number
): QuestLayoutConfig {
  const pageLayouts = PAGE_QUEST_LAYOUTS[pageIndex]
  const config = pageLayouts?.[layoutIndex]
  if (config) {
    return config
  }
  return MAIN_QUEST_LAYOUT[layoutIndex] ?? MAIN_QUEST_LAYOUT[1]
}
